import baseClass from "app/core/applicationBase";
import AppModule from "common/enums/AppModule";
import window from "common/objects/window";
import View from "app/forms/ExternalForms";
import loginOperations from "common/datasources/login/loginOperations";
import ExternalLogout from "app/login/logout/ExternalLogoutGlue";

export default $.extend({}, baseClass, {

    onLaunch: function() {
        window.name = AppModule.getDetails(AppModule.EXTERNAL_FORMS).name;
        this.showView(new View());
    },

    initializeSessionHandling: function() {
        if (window.self === window.top) {
            //Forms only need session handling if they aren't in a iframe
            //If they are embedded, session handling should be done by the embedding application
            baseClass.initializeSessionHandling.call(this);
        }
    },

    /**
     * Override
     * External forms doesn't have the standard session so logout will just destroy the view and show a status
     * @private
     */
    logout: function() {
        loginOperations.asyncLogout();
        this._clearWarning(true);
        this.showView(new ExternalLogout());
    },

    initLogoutMessageHandler() {},

    /**
     * Override
     * Prevent session manager from polling for session health since session cannot be renewed anywhere else
     * @private
     */
    _sessionTimeoutWarning: function(e) {
        baseClass._sessionTimeoutWarning.apply(this, arguments);
        e.preventDefault();
    }
});
